import React from 'react';
import ReactDOM from 'react-dom';
import { ApolloClient, InMemoryCache, ApolloProvider } from '@apollo/client';
import {
  BrowserRouter
} from "react-router-dom";

import App from './App';
import { captureAdClick } from './adSource';

const GRAPHQL_API_URL = process.env.REACT_APP_GRAPHQL_API_URL || 'https://api.bucketlistguitars.com/graphql';

// Park the partner click id before anything renders — the id only exists on the
// landing URL, and the router replaces that URL as soon as the seller moves off
// the cart page.
captureAdClick();

const client = new ApolloClient({
  uri: GRAPHQL_API_URL,
  cache: new InMemoryCache(),
});

ReactDOM.render(
  <React.StrictMode>
    <ApolloProvider client={client}>
      <BrowserRouter basename={'/sell'}>
        <App />
      </BrowserRouter>
    </ApolloProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
